import { render } from "./BChaoShow.vue?vue&type=template&id=bf7d96e2&scoped=true"
import script from "./BChaoShow.vue?vue&type=script&lang=js"
export * from "./BChaoShow.vue?vue&type=script&lang=js"

import exportComponent from "H:\\ideaProject\\vue\\fiveG-project\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf7d96e2"]])

export default __exports__